import { render, staticRenderFns } from "./ModalAddressValidation.vue?vue&type=template&id=5e507edc&"
import script from "./ModalAddressValidation.vue?vue&type=script&lang=js&"
export * from "./ModalAddressValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports